// Начертание трека сноса. Вынесено из MapCanvas ради проверяемости: подбор
// толщин на глаз уже один раз дал линию, неразличимую на фоне течений.
//
// Трек лежит ПОВЕРХ растра (порядок слоёв держит layerOrder.ts). Цвет — ЛАЗУРНЫЙ,
// тот же, что у маркера косяка (CLUSTER_COLOR), так что трек и его точки читаются
// как одно целое. Лазурный выбран как контраст к новой гамме течений «чёрный→
// зелёный» (с 2026-07-28) и как отличие от курс-синего маркера живого судна.

/** Толщина отрезка между «сегодня» и выбранным днём, px. */
export const TRACK_WIDTH_ACCENT = 2.6

/** Толщина остального пути («откуда косяк пришёл»), px. */
export const TRACK_WIDTH_CONTEXT = 1.4

/** Цвет трека — тот же лазурный, что у маркера косяка (clusterOpacity/setGeoJson). */
export const TRACK_COLOR = '#0ea5e9'

/** Нижняя граница затухания по возрасту. Возраст линия по-прежнему кодирует
 *  (так написано в легенде), но старый трек не должен исчезать вовсе. */
export const TRACK_OPACITY_FRESH = 0.95
export const TRACK_OPACITY_OLD = 0.55

/** Множитель для контекстной части: тише акцента, но всё ещё виден. */
export const TRACK_CONTEXT_FADE = 0.5

/** Шаг стрелок направления вдоль трека, px. */
export const TRACK_ARROW_SPACING_PX = 72

/** Размер стрелки направления вдоль трека, px. */
export const TRACK_ARROW_PX = 13
